const createScenario = {
  title: 'בנה תרחיש',

  form: {
    header: {
      title: 'שלום {{firstName}}',
    },
    fields: {
      sitePlaceHolder: 'מהו שם הפעילות שלך?',
    },

    footer: {
      confirmButtonText: {
        create: 'שמור',
        update: 'שמור',
      },
    },

    information: {
      details: {
        header: 'איזה תרחיש תרצה להריץ עם Moovex?',
        instructions: 'אנא סמן את התחום המתאר את תחום העיסוק שלך בצורה הטובה ביותר.',
      },
    },

    button: 'אני רוצה לבנות תרחיש',
  },
};

export default createScenario;
